<template>
    <div>
        <el-dialog :title="$t('view.投标授权委托书过期提醒')" :visible.sync="dialogVisible" width="1000px" :close-on-click-modal="false">
            <div style="color: #B80008;margin-bottom: 20px;" v-if="day!='notExpired'">
                <span  v-if="day>0">{{ $t('view.注：距离投标授权委托书过期还有') }}{{ day }}{{ $t('view.天') }},{{ $t('view.请尽快重新上传') }}</span>
                <span  v-else>{{ $t('view.投标授权委托书已过期，请尽快重新上传') }}</span>
            </div>
            <el-form ref="form" :model="form" :rules="rule" label-width="120px" style="display: flex;flex-wrap: wrap;">
                <el-form-item  :label="$t('view.投标授权委托书')" prop="authorizationFileList">
                    <div style="flex: 1" v-if="!form.authorizationFileList.length">
                        <el-upload :action="uploadFileBpm"  :limit="1"
                            :before-upload="beforeAvatarUpload"
                            :data="BpmData"
                            :class="{'hide': form.authorizationFileList.length==1}"
                            ref="authorizationFileList"
                            :headers="headers" :on-success="(res,file)=>{successList(form.authorizationFileList,res,file,'authorizationFileList')}"
                            :on-remove="(res,file)=>{handleRemove('authorizationFileList',res,file)}">
                            <img slot="trigger" style="vertical-align: middle;width: 320px;" :src="require('@/assets/BidDetails/icon-upload'+locale+'.png')">
                        </el-upload>
                    </div>
                    <div v-else style="display: flex;">
                        <File :clsoe="true" :listName="'authorizationFileList'" :file="form.authorizationFileList[0]"></File>
                    </div>
                    <span style="color: #1890ff;cursor: pointer;" @click="downloadTemplate">{{$t('view.下载模版')}}</span>
                </el-form-item>
                <el-form-item  :label="$t('view.委托书有效期 ')" prop="authorizationList">
                    <el-date-picker v-model="form.authorizationStart" style="width: 150px;"  value-format="yyyy-MM-dd" type="date" :placeholder="$t('view.请选择开始时间')"></el-date-picker>
                    <span style="margin: 0 8px">-</span> 
                    <el-date-picker v-model="form.authorizationEnd" style="width: 150px;" value-format="yyyy-MM-dd"  type="date" :placeholder="$t('view.请选择结束时间')"></el-date-picker>
                    <!-- <el-date-picker  style="width: 320px;" value-format="yyyy-MM-dd" v-model="form.authorizationList" type="daterange"></el-date-picker> -->
                </el-form-item>
                <el-form-item :label="$t('view.备注')" prop="remark">
                    <el-input  type="textarea" resize='none' :rows="3" style="width: 760px;" v-model="form.remark" ></el-input>
                </el-form-item>
                 <el-form-item :label="$t('view.招标联系人')">
                    <el-input style="width: 200px;" v-model="form.bpmNameStr" disabled>
                        <!-- <i v-if="form.bpmNameStr" slot="suffix" class="el-input__icon el-icon-circle-close" @click="claerbpmName"></i> -->
                    </el-input>
                    <el-button style="width: 120px;" type="primary" @click="bpmUserList">{{ $t('view.选择人员') }}</el-button>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submits">确 定</el-button>
            </span>
        </el-dialog>   
        <el-dialog :visible.sync="ContactsVisible" class="preview" :title="$t('view.选择招标联系人')" :append-to-body="true" width="60%">
            <el-form :model="queryParams" ref="queryBpmUserForm" :inline="true" @submit.native.prevent >
                <el-form-item label="招标联系人（企业认证审核人）" prop="userName">
                    <el-input
                        size="mini"
                        v-model="queryParams.userName"
                        clearable
                        @keyup.enter.native="handleCurrentChange(1)"
                        />
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" size="mini" @click="handleCurrentChange(1)">搜索</el-button>
                    <el-button icon="el-icon-refresh" size="mini" @click="queryParams.userName='';handleCurrentChange(1)">重置</el-button>
                </el-form-item>
            </el-form>
            <div style="color: #B80008;font-size: 14px;margin-bottom: 10px;"> 注：招标联系人请认真选择人员信息，选择错误会影响企业认证审批时效，若不清楚如何选择可联系项目招标公告中联系人或者业务对接人。</div>
            <el-table header-row-class-name="tableHeader" ref="multipleTable"  row-key="bpmId" border max-height="400" :data="listBpmUser" @selection-change="handleSelectionChange">
                <el-table-column type="selection" :reserve-selection="true" width="55" align="center" />
                <el-table-column align="center" fixed type="index" width="60" :label="$t('view.序号')"/>
                <el-table-column label="招标联系人（企业认证审核人）" align="center" prop="userName" />
                <el-table-column label="负责业务" align="center" prop="business" width="180">
                </el-table-column>
                <el-table-column label="状态" align="center" prop="business" width="180">
                    <template slot-scope="scope">
                        {{ scope.row.status==1?$t('view.正常'):$t('view.停用') }}
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination style="text-align: center;" layout="prev, pager, next"  :total="total" @current-change="handleCurrentChange"></el-pagination>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submit">{{ $t('view.确 定') }}</el-button>
                <el-button @click="ContactsVisible=false;handleSelection=[];queryParams.userName='';queryParams.pageNum=1">{{ $t('view.取 消') }}</el-button>
            </div>
        </el-dialog>                                 
    </div>
</template>
    
<script>

import { uploadFileBpm } from '@/utils/request'
import { getToken } from "@/utils/auth";
import {authorizationDownLoad,bpmUserList} from '@/api/project'
import {PostWebBook,PutWebBook} from '@/api/index'
import File from '@/components/file.vue'
  export default {
    components: {File },
    data(){
        const validateTime = (rule, value, callback) => {
            if (!(this.form.authorizationStart&&this.form.authorizationEnd)) {
                callback(new Error(this.$t('view.请选择')))
            }else if(new Date(this.form.authorizationStart).valueOf()>= new Date(this.form.authorizationEnd).valueOf()){
                callback(new Error(this.$t('view.开始时间不得大于结束时间')))
            }else if (new Date().valueOf()>=new Date(this.form.authorizationEnd).valueOf()) {
                callback(new Error(this.$t('view.大于当前系统时间')))
            } else {
                callback()
            }

        }
      return{
        dialogVisible:false,
        ContactsVisible:false,//选择招标联系人
        form:{
            authorizationFileList:[],
        },
        uploadFileBpm,
        url:'',
        BpmData:{type:'qyrzlc'},
        locale: localStorage.getItem('locale')||'zh',
        headers: {
            Authorization:getToken(),
        },
        queryParams:{
            pageNum: 1,
            pageSize: 10,
            userName: null,
        },//招标联系人的表单
        listBpmUser:[],
        handleSelection:[],//选择的数据
        total:0,
        day:0,
        rule:{
            authorizationFileList:[{ required: true, message: this.$t('view.请上传'), trigger: "change" }],
            authorizationList:[{ required: true, validator: validateTime  ,trigger: "change" }],
        },
      }
    },
    methods:{
         // 重新上传
        reuploadClick(list){
            this.$set(this.form,list,[])
            this.$forceUpdate()
        },
         // 附件查看与下载
        handleViewFile(filePath, fileName) {
            const ext = filePath.substr(filePath.lastIndexOf('.') + 1, filePath.length)
            if (ext == 'pdf' || 'PDF') {
                window.open(filePath, "_blank");
            } else {
                const eLink = document.createElement("a");
                eLink.download = fileName;
                eLink.style.display = "none";
                eLink.href = filePath;
                document.body.appendChild(eLink);
                eLink.click();
                eLink.remove()
            }
        },
        submits(){
            this.$refs.form.validate((a) => {
                if (a) {
                    const loading = this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    let data =JSON.parse(JSON.stringify(this.form))
                    if(data.status==3){
                         PutWebBook(data).then((res) => {
                            loading.close();
                            setTimeout(window.location.reload(), 1500);
                        })
                    }else{
                        PostWebBook(data).then((res) => {
                            loading.close();
                            setTimeout(window.location.reload(), 1500);
                        });
                    }
                }
            });
        },
        show(form,day){
            this.form=JSON.parse(JSON.stringify(form))
            if(!this.form.authorizationFileList)
            this.form.authorizationFileList=[]
            this.day=day
            this.dialogVisible=true
        },
        submit(){
            this.ContactsVisible=false
            this.form.bpmIdStr= this.handleSelection.map(item=>item.bpmId).join(',')
            this.form.bpmNameStr= this.handleSelection.map(item=>item.userName).join(',')
        },
        handleSelectionChange(e){
            this.handleSelection=e
        },  
        handleCurrentChange(e){
            this.queryParams.pageNum=e
            this.bpmUserList()
        },
        bpmUserList(){
            bpmUserList(this.queryParams).then(res=>{
                this.listBpmUser = res.rows;
                this.total = res.total;
                this.ContactsVisible=true
                this.$nextTick(function(){
                    this.listBpmUser.map(item=>{
                        this.$refs.multipleTable.toggleRowSelection(item, false)
                    })
                    if(this.form.bpmIdStr){
                        let list =this.form.bpmIdStr.split(",");
                        list.map(item=>{
                            this.listBpmUser.map(i=>{
                                if(item==i.bpmId){
                                    this.$refs.multipleTable.toggleRowSelection(i, true)
                                }
                            })
                        })
                    }
                })
             
            })
        },
        beforeAvatarUpload(file){
          // image/png zip rar pdf
        if((!file.type.includes('pdf'))&&(!file.type.includes('image'))&&(!file.type.includes('zip'))&&(!file.type.includes('application/x-compressed'))){
            this.$message.error(this.$t('view.格式有误'));
            return false
        }
        return true
      },
      // 上传文件
      successList(list,res,file,ref){
          // 上传失败
          if(res.code!=200){
            this.$refs[ref].clearFiles();
            return
          }
          if(!list)
          list=[]
          list.push({
              fileName:file.response.data.newFileName,
              filePath:file.response.data.url,
              url: file.response.data.url, 
              type:file.response.data.newFileName.split(".").pop(),
              fileSize:file.size,
              bpmFileId:file.response.data.bpmFileId

          })
      },
      // 删除
      handleRemove(list, file, fileList) {
        this.$set(this.form,list,[])
        fileList.map(item=>{
            this.form[list].push({
                fileName:item.response.originalFilename,
                filePath:item.response.fileName,
                url: item.response.url, 
            })
        })
      },
       downloadTemplate(){
        authorizationDownLoad().then(res=>{
            const blob = new Blob([res]);
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = this.$t('view.投标授权委托书模板.docx');
            link.click();
        })
    },
    }
  };
  </script>
   